<script setup>
defineProps({
  item: {
    type: Object,
    default: () => ({
      gift: {},
      value: 0
    }),
    required: true
  }
})
</script>

<template>
  <div class="flex flex-col items-center gap-1">
    <img
      :src="item.gift.imageUrl"
      class="aspect-square w-full"
      alt="Gift">

    <span class="text-sm font-semibold text-gray-500">
      {{ item.value }}
    </span>
  </div>
</template>